import React, { FC } from "react";
import { Paper, Theme, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { ReactComponent as BiologicsSVG } from "../../svgs/biologics.svg";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  biologicChip: {
    width: "2rem",
    height: "3rem",
    backgroundColor: theme.palette.background.paper,
    position: "absolute",
    borderRadius: "0.2rem",
    top: "0.8rem",
    left: "0.8rem",
  },
  biologicIcon: {
    width: "100%",
    height: "100%",
  },
  title: {
    fontSize: "1.2rem",
  },
}));

interface HeaderProps {
  brandName: string;
  isBiologic: boolean;
}

const Header: FC<HeaderProps> = ({ brandName, isBiologic }) => {
  const classes = useStyles();

  return (
    <header className={classes.container}>
      {isBiologic && (
        <Paper elevation={1} className={classes.biologicChip}>
          <BiologicsSVG className={classes.biologicIcon} />
        </Paper>
      )}
      <Typography className={classes.title}>{brandName}</Typography>
    </header>
  );
};

export default Header;
